import React, { useEffect, useMemo } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../config/userProvider";
import { FaTachometerAlt } from "react-icons/fa";
import { RiArchiveDrawerLine } from "react-icons/ri";
import { GoOrganization } from "react-icons/go";
import { BiPurchaseTag } from "react-icons/bi";
import { MdOutlineInventory2 } from "react-icons/md";

const Sidebar = () => {
  const { userData } = useUser();
  const location = useLocation();
  const navigate = useNavigate();

  // Dropdown state (if needed)
  // const [openDropdowns, setOpenDropdowns] = useState({});

  // Stable NavigationData using useMemo
  const NavigationData = useMemo(
    () => [
      { title: "Dashboard", icon: <FaTachometerAlt />, location: "/dashboard", permission: "fms" },
      { title: "Materials", icon: <RiArchiveDrawerLine />, location: "/materials", permission: "fms" },
      { title: "Suppliers", icon: <GoOrganization />, location: "/suppliers", permission: "fms" },
      { title: "Purchase Orders", icon: <BiPurchaseTag />, location: "/purchase-orders", permission: "fms" },
      { title: "Inventory", icon: <MdOutlineInventory2 />, location: "/inventory", permission: "fms" },
    ],
    []
  );

  // Update dropdowns based on current location
  useEffect(() => {
    const updatedOpenDropdowns = {};
    NavigationData.forEach((item) => {
      if (
        item.subMenu &&
        item.subMenu.some((subItem) => subItem.location === location.pathname)
      ) {
        updatedOpenDropdowns[item.title] = true;
      }
    });
    // setOpenDropdowns(updatedOpenDropdowns);
  }, [NavigationData, location.pathname]);

  const permissions = userData?.permissions || [];

  return (
    <>
      <div className="flex flex-col gap-1 items-center w-full h-full overflow-y-scroll py-2 hide-scrollbar">
        {(userData?.userType === "master" ? NavigationData : NavigationData.filter((item) =>
          permissions.some((perm) => perm.resource === item.permission && perm.read)
        )).map((item, index) => (
          <NavLink
            key={index}
            to={item.location}
            className={({ isActive }) =>
              `px-3 py-2 rounded-lg w-full flex items-center gap-2 text-sm ${
                isActive
                  ? userData?.userType === "master"
                    ? "text-[#4B49AC] bg-white"
                    : "bg-[#d8c9ae] text-[#575757]"
                  : userData?.userType === "master"
                  ? "hover:bg-[#7978e9] text-white"
                  : "hover:bg-[#7978e9] text-[#d8c9ae]"
              }`
            }
          >
            <span className="text-xl">{item.icon}</span>
            <p className="sm:hidden lg:block">{item.title}</p>
          </NavLink>
        ))}
      </div>

      <div
        onClick={() => navigate("/account")}
        className="flex text-white items-center gap-3 cursor-pointer px-3 py-2 rounded-md hover:bg-red-600 hover:text-white transition-colors border w-full"
      >
        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-500 text-white uppercase">
          {userData?.firstName?.charAt(0)}
        </div>
        <div className="flex flex-col">
          <span className="font-medium text-sm truncate">
            {userData?.firstName} {userData?.lastName}
          </span>
          <span className="font-medium text-[9px]">{userData?.email}</span>
        </div>
      </div>
    </>
  );
};

export default Sidebar;